import axios from "axios";
import React, { Component } from "react";
// get our fontawesome imports
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SweetAlert from "react-bootstrap-sweetalert";

class WeddingLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      alert: null,
      message: "",
      errors: [],
    };
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.hasErrorFor = this.hasErrorFor.bind(this);
    this.renderErrorFor = this.renderErrorFor.bind(this);
  }

  componentDidMount() {
    axios
      .get(`${window.localhost}/wedding`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          this.props.history.push("/admin-wedding/index");
        }
      });
  }

  handleFieldChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  goToHome() {
    const getAlert = () => (
      <SweetAlert
        success
        title="Success!"
        onConfirm={() => this.onSuccess()}
        onCancel={this.hideAlert()}
        timeout={2000}
        confirmBtnText="Oke Siap"
      >
        {this.state.message}
      </SweetAlert>
    );
    this.setState({
      alert: getAlert(),
    });
  }

  onSuccess() {
    this.props.history.push("/admin-wedding/index");
  }

  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  handleLogin(event) {
    event.preventDefault();

    const formData = new FormData();
    formData.append("username", this.state.username);
    formData.append("password", this.state.password);

    axios
      .post(`${window.localhost}/admincre/login`, formData)
      .then((response) => {
        // redirect to the homepage
        var msg = response.data.success;
        if (msg == true) {
          this.setState({
            message: response.data.message,
          });
          localStorage.setItem("Authorization", response.data.token);
          return this.goToHome();
        }
      })
      .catch((error) => {
        console.log(error.response.data);
        this.setState({
          errors: error.response.data,
        });
      });
  }

  hasErrorFor = (field) => {
    return !!this.state.errors[field];
  };

  renderErrorFor(field) {
    if (this.hasErrorFor(field)) {
      return (
        <span className="invalid-feedback">
          <strong>{this.state.errors[field][0]}</strong>
        </span>
      );
    }
  }

  render() {
    return (
      <div className="bg-white">
        <div className="container-fluid pt-6 overflow-hidden">
          <div className="container my-4 py-3">
            <div className="container col-12 col-sm-8 p-3 p-sm-4">
              <h2 className="fw-bold text-center">Creatifa Wedding Login</h2>
              <h2 className="fw-bold text-center">
                <div className="grey-line me-2"> </div>
                <FontAwesomeIcon icon={faHeart} className="fs-4 pink-heart" />
                <FontAwesomeIcon icon={faHeart} className="fs-4 grey-heart" />
                <div className="grey-line ms-2"> </div>
              </h2>
              <hr />

              <form onSubmit={this.handleLogin}>
                <div className="row mb-3">
                  <div className="col">
                    <label htmlFor="username" className="form-label">
                      Username
                    </label>
                    <input
                      type="text"
                      id="username"
                      name="username"
                      value={this.state.username}
                      className={`form-control ${
                        this.hasErrorFor("username") ? "is-invalid" : ""
                      }`}
                      onChange={this.handleFieldChange}
                    />
                    {this.renderErrorFor("username")}
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col">
                    <label htmlFor="password" className="form-label">
                      Password
                    </label>
                    <input
                      type="password"
                      id="password"
                      name="password"
                      value={this.state.password}
                      className={`form-control ${
                        this.hasErrorFor("password") ? "is-invalid" : ""
                      }`}
                      onChange={this.handleFieldChange}
                    />
                    {this.renderErrorFor("password")}
                  </div>
                </div>

                <button type="submit" className="btn btn-primary me-3 px-4">
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
        {this.state.alert}
      </div>
    );
  }
}

export default WeddingLogin;
